import { Close } from '@bnnvara/icons/src/components/UserInterfaceIcons/Close';
import { Search } from '@bnnvara/icons/src/components/UserInterfaceIcons/Search';
import React from 'react';

import useUI, { TYPE_TOGGLE_SEARCH } from '../../../hooks/useUI';
import * as S from './styled';

export function SearchButton() {
  const {
    state: { searchOpen },
    dispatch,
  } = useUI();

  return (
    <S.SearchButton onClick={() => dispatch({ type: TYPE_TOGGLE_SEARCH })}>
      {searchOpen ? (
        <Close width="100%" height="100%" color="#000" />
      ) : (
        <Search width="100%" height="100%" color="#000" />
      )}
    </S.SearchButton>
  );
}
